import  React,{Component} from 'react';
import axios from 'axios'; 
import Serverurl from './Apiurl';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import TableBody from '@mui/material/TableBody';
import Paper from '@mui/material/Paper';  
import Table from '@mui/material/Table'; 
import TableContainer from '@mui/material/TableContainer';  
import TableRow from '@mui/material/TableRow';  
import TableHead from '@mui/material/TableHead';  
import TableCell from '@mui/material/TableCell'; 
import TableSortLabel from '@mui/material/TableSortLabel'; 
import PropTypes from 'prop-types';
import TablePagination from '@mui/material/TablePagination';  
import { styled } from '@mui/styles'; 
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { NavLink,Navigate  } from 'react-router-dom';
import Radio from '@mui/material/Radio';

const MMCbranchid=0;

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}


function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}


const headCells = [



]

function EnhancedTableHead(props) {
  const {  order, orderBy,   onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };
  
  
return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = styled(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));


const EnhancedTableToolbar = props => {
const classes = useToolbarStyles();
const { numSelected } = props;

  
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = styled(theme =>({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 

  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
 
form: {
    width: '500%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
	 minWidth: 120,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  
   textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  
})
)
export default  class Teachersubject extends Component{ 

	constructor(props){
	super(props)
		this.state={
			Brancharr:[],Classarr:[],subarra:[],btndisabled:false,classid:"0",teacherarr:[],subid:"0",BatchData:[],branchid:0,submitbtn:'Save',
			redirect:false,btndisabled:false,errormessage:'',erropen:false,errortype:'error',teacherdata:[],ts_ur_id:0,ts_sb_id:'',sylabus:0,allchecked:false,
			
		}
		
		
		
	}
	
	componentWillMount() {
		
	
localStorage.setItem("pageactive",12)

			document.title = "MM Coching Center - Bulk Attendance";
	
	if(localStorage.getItem("MMCrole")==="1" )
		  {
		 this.BranchBind(); 
		  }
		this.TeacherBind();  this.ClassBind();
		
	}
	
myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
 	   this.setState({[nam]: val}, () => {
		   
		  if( this.state.branchid!="0")
	   {
		this. TeacherBind();      
 
	   } 
		if( this.state.subid!="0" && this.state.classid!="0")
	   {
		this.GetBatchByclassAndBatch();	    
		this.SubjectBind();
	   } 
	
	
	
	   
}); 
 
}
BranchBind()
{
	axios.get(Serverurl+'ajaxbranch.php?action=getall')
       .then(resp => { 		
			if(resp.data.length>0){
				this.setState({
						Brancharr:resp.data	
							}) 
			}
	
	   }) .then(data => {
        let branchFromApi = this.state.Brancharr.map(row => {
                          
          return {value: row.br_id, display:row.br_title}
        });
      
		
        this.setState({
          Brancharr: [{value: '0', display: 'Select Branch'}].concat(branchFromApi)
        });
      })
this.ClassBind();
}

ClassBind()
{
	axios.get(Serverurl+'ajaxtrustandclass.php?action=getall&tc_type=2')
       .then(resp => { 		
			if(resp.data.length>0){
				this.setState({
						Classarr:resp.data	
							}) 
			}
	
	
	   }) .then(data => {
        let classFromApi = this.state.Classarr.map(row => {
                          
          return {value: row.tc_id, display:row.tc_title}
        });
      
		
        this.setState({
          Classarr: [{value: '0', display: 'Select Class'}].concat(classFromApi)
        });
      })  
	 

}
SubjectBind()
{

	axios.get(Serverurl+'ajaxsubjects.php?action=getall&sb_class_id='+this.state.classid+'&sb_syllabustype='+this.state.sylabus)
       .then(resp => { 		
			if(resp.data.length>0){
				this.setState({
						subarra:resp.data	
							}) 
			}
	
	
	   }) .then(data => {
        let classFromApi = this.state.subarra.map(row => {
                          
          return {value: row.sb_id, display:row.sb_title}
        });
      
		
        this.setState({
          subarra: [{value: '0', display: 'Select Subject'}].concat(classFromApi)
        });
      })
	  
	 
	  
}



TeacherBind() {
	

    let branchid = 0; 
    if (localStorage.getItem('MMCrole') !== "1") {
        branchid = localStorage.getItem('MMCbranchid');
    } else {
        branchid = this.state.branchid;
    }

    axios.get(Serverurl + 'ajaxteachersubject.php?action=teacherbind&ur_role=3&ur_br_id=' + branchid)
        .then(resp => {
            if (resp.data.length > 0) {
                this.setState({
                    teacherarr: resp.data
                })
            }
        }).then(() => {
            let classFromApi = this.state.teacherarr.map(row => {
                return { value: row.ur_id, display: row.ur_username }
            });

            this.setState({
                teacherarr: [{ value: '0', display: 'Select Teacher' }].concat(classFromApi)
            });
        })
		
		
		
}



GetBatchByclassAndBatch(){
    let branchid = 0; 
    if (localStorage.getItem('MMCrole') !== "1") {
        branchid = localStorage.getItem('MMCbranchid');
    } else {
        branchid = this.state.branchid;
    }

	
  axios.get(
    Serverurl + 'ajaxteachersubject.php?action=getall'+'&bc_class_id=' + this.state.classid +'&bc_br_id=' + branchid +'&ts_sb_id='+this.state.subid+'&ts_ur_id='+this.state.ts_ur_id
  )
  .then(resp => {  
		  const totalcount=resp.data.length;
		  
		   const selectedCount = resp.data.filter(item => item.isseleceted === "1").length;

	if(selectedCount===totalcount){
		this.setState({  
			  allchecked:true,  
			
			})
			
	}
	else{
		
		this.setState({  
			  allchecked:false,  
			
			})	
	}
    if(resp.data.length>0){
		
			this.setState({  
			  BatchData: resp.data,  
			
			});
     }
	 else{
		   this.setState({BatchData:[],});
	 }
   
    });

}





HandleCheckbox = (id, rowsd) => {
  const updatedArray = [...this.state.BatchData];

  const isSelected = updatedArray[rowsd].isseleceted === "1";
  updatedArray[rowsd].isseleceted = isSelected ? "0" : "1";

  let updatedTeacherData = [...this.state.teacherdata];

  const currentItem = updatedArray[rowsd];

  if (!isSelected) {
    const alreadyExists = updatedTeacherData.some(item => item.bc_id === currentItem.bc_id);
    if (!alreadyExists) {
      updatedTeacherData.push(currentItem);
    }
  } else {
    updatedTeacherData = updatedTeacherData.filter(item => item.bc_id !== currentItem.bc_id);
  }

  this.setState({
    BatchData: updatedArray,
    teacherdata: updatedTeacherData
  }, () => {
   
  });
};


handleSubmit = (event) => {


  let optionsVal = this.state.BatchData;
  let optionValues = "";
  let sep1 = "";



  if (this.state.ts_ur_id=== "") {
    this.setState({errormessage: "Please Select Teacher",erropen: true,errortype: 'error'
    });
    window.scrollTo({ top: 0 });
    return false;
  }
if (this.state.classid===0) {
    this.setState({errormessage: "Please Select Class",erropen: true,errortype: 'error'
    });
    window.scrollTo({ top: 0 });
    return false;
  }
  if (this.state.sylabus=== 0) {
    this.setState({errormessage: "Please Select Syllabus",erropen: true,errortype: 'error'
    });
    window.scrollTo({ top: 0 });
    return false;
  }
 

  if (this.state.subid=== "") {
    this.setState({errormessage: "Please Select Subject",erropen: true,errortype: 'error'
    });
    window.scrollTo({ top: 0 });
    return false;
  }
  
  
   

var strvalidate="0";
  optionsVal.forEach(eachval => {
   if(eachval.isseleceted=="1")
	   
	   {
		   strvalidate="1";
	   
   
      optionValues += sep1+eachval.bc_id + "~" + eachval.isseleceted;
      sep1 = "`";
	  }
    
  });
  

  if (strvalidate === "0") {
    this.setState({errormessage: "Please Select Atleast One Batch",erropen: true,errortype: 'error'
    });
    window.scrollTo({ top: 0 });
    return false;
  }

 
this.setState({errormessage: "",erropen: false,errortype: 'error',btndisabled:true,submitbtn:'Processing...'
    });
  const formData = new FormData();
  formData.append('action', 'insert');
  formData.append('teachersubject', optionValues);
  formData.append('ts_ur_id', this.state.ts_ur_id);
  formData.append('ts_sb_id', this.state.subid);
  formData.append('userid', localStorage.getItem('MMCuserid'));

  formData.append('ts_br_id', localStorage.getItem('MMCbranchid'));
  axios.post( Serverurl + 'ajaxteachersubject.php', formData)
    .then(res => {
     
	 let strreturnValue=res.data;
	 
	 if(strreturnValue===1){
	 this.setState({erropen:true,btndisabled:false,submitbtn:'Save',errortype:'success',errormessage:'Batch Succesfully Assigned',subid:0,ts_ur_id:'',branchid:0,classid:0,BatchData:[],allchecked:false});
		 	 window.scrollTo({top: 0})
		 return false;
		 
	 }
	 
	 
	  if(strreturnValue===0){
		 this.setState({erropen:true,btndisabled:false,submitbtn:'Save',errortype:'info',errormessage:'Batch Succesfully Unassigned',subid:0,ts_ur_id:'',branchid:0,classid:0,BatchData:[],allchecked:false});
		 	 window.scrollTo({top: 0})
		 return false;
		 
	 }
	 
	
	 
    })
  
}





handleSyllabusChange = (event) => {
 
	 
  let nam = event.target.name;
  let val = event.target.value;

	  
	   this.setState({[nam]: val,}, () => {
		   
		   
if(this.state.classid!="0" & this.state.sylabus!==0)
	   {
		  
 	this.SubjectBind();
	
	
	   }
});  
}



handleErrorclose=(event)=>{
	this.setState({erropen:false,});
	
}













	 HandleAllcheckbox=()=>{
 var studArray = this.state.BatchData;
	 
	 const updatedArray = [...this.state.BatchData];
	 
	 console.log('bulkdata',updatedArray);
	 
	 this.setState({allchecked:!this.state.allchecked},() => {
	     if(this.state.allchecked===false)
		 {
			
		 var subnewRow=studArray.map((rowssub,j) => {
					 updatedArray[j].isseleceted = "0" ;
				 });
				
		 
				 
		  }
		 else if(this.state.allchecked===true)
			 
			 {
				
				  var subnewRow = studArray.map((rowssub, j) => {
				   updatedArray[j].isseleceted = "1" ;
			   });
				 
			 }
			 this.setState({BatchData:updatedArray,},()=>{
				 
				 console.log(this.state.BatchData);
			
			 });
		 
	 }); 
	 
	 
  }






	render(){
		
		if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
		
		
		return(
		  <React.Fragment>
   
<div className="containermain">
<div className="boxheading">
				  <div className="contntpad">
<h2>Subject Allocation</h2>
</div></div>




<div className="searchmaster">

<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.errortype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
<ul>

{localStorage.getItem('MMCrole') === "1" && (
  <li>
    <p><span className="validation">*</span>Branch</p>
    <p>
      <FormControl fullWidth size="small">
        <Select
          native
          variant="outlined"
          margin="normal"
          defaultValue={{ label: this.state.branchlabel, value: this.state.branchid }}
          onChange={this.myChangeHandler}
          id="state"
          value={this.state.branchid}
          name="branchid"
        >
          {this.state.Brancharr.map(row => (
            <option key={row.value} value={row.value}>
              {row.display}
            </option>
          ))}
        </Select>
      </FormControl>
    </p>
  </li>
)}



	  <li><p><span className="validation">*</span>Teacher</p>
	  <p>
	  <FormControl fullWidth  size="small">
       
        <Select
         native
		  variant="outlined"
          margin="normal"
		
          onChange={this.myChangeHandler}
          id="ts_ur_id"
		  value={this.state.ts_ur_id}
		  name="ts_ur_id"
		
		
        >
		{this.state.teacherarr.map(row => (
            <option  
            
              value={row.value}
            >
              {row.display}
            </option  >
          ))}
		
        </Select>
 </FormControl></p>
	  
	  </li>


  <li><p><span className="validation">*</span>Class</p>
	  <p>
	  <FormControl fullWidth  size="small">
       
        <Select
         native
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.classlabel, value: this.state.classid }}
          onChange={this.myChangeHandler}
          id="state"
		   value={this.state.classid}
		  name="classid"
		
		
        >
		{this.state.Classarr.map(row => (
            <option  
            
              value={row.value}
            >
              {row.display}
            </option  >
          ))}
		
        </Select>
 </FormControl></p>
	  
	  </li>
	  
	  
	  
	   <li><p><span className="validation">*</span> Sylabus Type</p>
	  <Radio
        checked={this.state.sylabus === '2'}
        onChange={this.handleSyllabusChange}
        value="2"
        name="sylabus"
        inputProps={{ 'aria-label': 'B' }}
      />State<Radio
        checked={this.state.sylabus === '1'}
        onChange={this.handleSyllabusChange}
        value="1"
        name="sylabus"
        inputProps={{ 'aria-label': 'A' }}
      />CBSE
    <Radio
        checked={this.state.sylabus === '3'}
        onChange={this.handleSyllabusChange}
        value="3"
        name="sylabus"
        inputProps={{ 'aria-label': 'A' }}
      />PUC

	  
	 </li>
	  
	  {this.state.sylabus!==0 && (
	  
	  <li><p><span className="validation">*</span>Subject</p>
	  <p>
	  <FormControl fullWidth  size="small">
       
        <Select
         native
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.classlabel, value: this.state.subid }}
          onChange={this.myChangeHandler}
          id="state"
		   value={this.state.subid}
		  name="subid"
		
		
        >
		{this.state.subarra.map(row => (
            <option  
            
              value={row.value}
            >
              {row.display}
            </option  >
          ))}
		
        </Select>
 </FormControl></p>
	  
	  </li>
	  )}
	  
	  
	  
	  
	  
</ul>

</div>
<div className="batchlist">
  <Paper className={useStyles.root}>
    <TableContainer className={useStyles.container}>
      <Table stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>
            <TableCell style={{ width: "20%" }}>Batch</TableCell>
            <TableCell>   
			<Checkbox 
           checked={this.state.allchecked}
           onChange={()=>{this.HandleAllcheckbox()}}
            inputProps={{ 'aria-label': 'controlled' }}
         
              /> 
                                              
              </TableCell>  
          </TableRow>
        </TableHead>
        <TableBody>
          {this.state.BatchData.map(
            (item, index) => (
              <TableRow key={index}>
                <TableCell>{item.bc_title}</TableCell>
               <TableCell>{item.isseleceted==="0" && (
<Checkbox
  
  onChange={()=>{this.HandleCheckbox(item.bc_id,index)}}
  inputProps={{ 'aria-label': 'controlled' }}
/> 
)}{item.isseleceted==="1" && (
<Checkbox
  checked
  onChange={()=>{this.HandleCheckbox(item.bc_id,index)}}
  inputProps={{ 'aria-label': 'controlled' }}
/> 
)}</TableCell>

              </TableRow>
            )
          )}

          {this.state.BatchData.length === 0 && (
            <TableRow>
              <TableCell colSpan="4">
                <h5 className="aligncenter">No Records</h5>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>

 
  </Paper>
</div>
{this.state.BatchData.length !== 0 && (
<p className="aligncenter"><Button variant="standard" disbaled={this.state.btndisabled} className="frmPrimarybtn" endIcon={<CheckRoundedIcon />} onClick={this.handleSubmit}>
	{this.state.submitbtn}
	</Button></p>
	)}
</div>


  </React.Fragment>
   
		);
		
		
	}
	
	
}

